
export const CoachRecommendationView = ({ recommendation }) => {
  // Handle different data structures for recommendation
  const recommendationUrl = recommendation?.url || recommendation?.documentUrl || recommendation;

  // Check if recommendation exists
  if (!recommendation || !recommendationUrl) {
    return (
      <div className="rounded-2xl p-4 sm:p-6 border-slate-700/50">
        <h3 className="text-white font-bold text-base sm:text-lg mb-3 sm:mb-4">COACH RECOMMENDATION</h3>
        <div className="p-6 rounded-xl bg-slate-800/50 border border-slate-700/50 text-center">
          <p className="text-slate-400 text-sm">No coach recommendation available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-2xl p-4 sm:p-6 border-slate-700/50">
      <h3 className="text-white font-bold text-base sm:text-lg mb-3 sm:mb-4">COACH RECOMMENDATION</h3>

      <div className="p-6 rounded-xl bg-slate-800/50 border border-slate-700/50">
      </div>
    </div>
  );
};

export default CoachRecommendationView;
